// todo move this file to module
export let ChatActivityOptions = {
    '1': 'روشن',
    '0': 'خاموش',
}